import { t } from "i18next";

export const statusReturn = (status) => {
    switch (status) {
        case true:
            return t("active");
        case false:
            return t("deActive");
        case "De-Active":    
        case "Inactive":
            return t("deActive");
        case "PendingForApproval":
            return t("pendingForApproval");
        case "Approved":
            return t("approved");
        case "Active":
            return t("active");
        case "Rejected":
            return t("rejected");
        case "Expired":
            return t("expired");
        default:
            return t("na");
    }
};

export const statusClass = (statusValue) => {
    switch (statusValue) {
        case "Pending For Approval":
        case t("pendingForApproval"):
            return "pendingApproval";
        case true:
        case t("approved"):
        case t("active"):
            return "activeStatus";
        case false:
        case t("expired"):
        case t("inactive"):
        case t("deActive"):
            return "inActiveStatus";
        case t("rejected"):
            return "inActiveStatus";
        default:
            return "";
    }
}

export const getResolvedStatusValue = (row) => {
    let value = "";

    if (row.documentWorkFlowStatus && row.documentWorkFlowStatus !== null && row.isActive) {
        value = row.documentWorkFlowStatus;
    } else if (row.documentWorkFlowStatus === "Approved") {
        value = false;
    } else if (row.documentWorkFlowStatus === "Rejected") {
        value = row.documentWorkFlowStatus;
    } else if (row.status !== undefined) {
        value = row.status;
    } else if (row.isActive !== undefined) {
        value = row.isActive;
    }

    return statusReturn(value);
};

export const statusSortFunction = (a,b) => {
    const aStatus = getResolvedStatusValue(a)?.toLowerCase() ?? '';
    const bStatus = getResolvedStatusValue(b)?.toLowerCase() ?? '';

    return aStatus.localeCompare(bStatus);
};